import React, { useState } from 'react';

import useContactUsAPI from "../../api/useContactUsAPI";

import './ContactUs.css';
import { GrLocation, GrMailOption, GrPhone } from "react-icons/gr";



const ContactUs: React.FC = () => {

    const { sendContactMessage } = useContactUsAPI();
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        message: '',
    });



    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };


    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        console.log("Form submitted:", formData);
        alert("Message sent successfully!");
        try {
            const response: any = await sendContactMessage(payload);
            console.log("Response:", response);
            if (response.status === 200 || response.status === 201) {
                alert("Message sent successfully!");
            }
        } catch (error) {
            console.error("Error sending message:", error);
            alert("Failed to send message. Please try again later.");
        }
        // Reset form
        setFormData({ firstName: '', lastName: '', email: '', message: '' });

    };

    const payload = {
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        message: formData.message,
    };

    // You can call your API here with the payload
    // For example:
    // useContactUsAPI().sendContactMessage(payload)

    // .then(response => {
    //     console.log("Response:", response);
    // })
    // .catch(error => {
    //     console.error("Error sending message:", error);
    // });



    return (
        <div className="contact-us-container">
            <div className="contact-us-info">
                <div className="contact-us-header">
                    <div className="text-900 font-medium mb-4">Contact Us</div>
                    <h1 className='text-900 text-2xl font-bold mb-4'>GET IN TOUCH</h1>
                    <p className='text-700 line-height-3 pr-0 lg:pr-5'>
                        Whether you're looking for the perfect tires for your vehicle, need a battery replacement, or require our expert services, we're here to help...
                    </p>
                </div>
                <div className="contact-us-address">
                    <span className='flex align-items-center justify-content-center surface-100 border-round mr-3 p-2'>
                        <GrLocation className='text-900 text-4xl' />
                    </span>
                    <div>
                        <h2 className='text-xl text-900 mb-2 font-medium'>Corporate Address :</h2>
                        <p className='text-700 line-height-3'>
                            Junction of Tyres Private Limited <br />
                            {/* Shop-4,10 B-wing, SRA Rehab building, Rani Sati Marg, Malad East, Mumbai, Maharashtra 400097 */}
                            101, 2nd Avenue, Atul Projects, Subhash Nagar ,Andheri (E) Mumbai-400093
                        </p>
                    </div>
                </div>
                <div className="contact-us-email flex-column">
                    <div className="contact-us-email">
                        <span className='flex align-items-center justify-content-center surface-100 border-round mr-3 p-2'>
                            <GrMailOption className='text-900 text-4xl' />
                        </span>
                        <div>
                            <h2 className='text-xl text-900 mb-2 font-medium'>Email</h2>
                            <p className='text-700 line-height-3'>Info@mechmiles.com</p>
                        </div>
                    </div>
                    <div className="contact-us-email">
                        <span className='flex align-items-center justify-content-center surface-100 border-round mr-3 p-2'>
                            <GrPhone className='text-900 text-4xl' />
                        </span>
                        <div>
                            <h2 className='text-xl text-900 mb-2 font-medium'>Company Official No:</h2>
                            <p className='text-700 line-height-3'>+91 7977016395</p>
                        </div>
                    </div>
                </div>

                {/* Contact Form */}
                {/* <form className="contact-form" onSubmit={handleSubmit}>
                    <div className="form-row">
                        <input
                            type="text"
                            name="firstName"
                            placeholder="First Name"
                            value={formData.firstName}
                            onChange={handleChange}
                            required
                        />
                        <input
                            type="text"
                            name="lastName"
                            placeholder="Last Name"
                            value={formData.lastName}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <input
                        type="email"
                        name="email"
                        placeholder="Email ID"
                        value={formData.email}
                        onChange={handleChange}
                        required
                    />
                    <textarea
                        name="message"
                        rows={5}
                        placeholder="Your Message"
                        value={formData.message}
                        onChange={handleChange}
                        required
                    ></textarea>


                    <button type="submit" className="send-btn">Send Message</button>
                </form> */}
            </div>

            <div className="map">
                {/* <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7536.5930935915285!2d72.84936814122702!3d19.182245828176928!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b73f30d5fb87%3A0x30b964c461f79f94!2sMechmiles!5e0!3m2!1sen!2sin!4v1736753342815!5m2!1sen!2sin" width="600"
                    height="450"
                    style={{ border: 0 }}
                    allowFullScreen={false}
                    loading="lazy"></iframe> */}

                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d235.6001120222451!2d72.86878131330015!3d19.12511751208625!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c9007f686f75%3A0xa8882b9db69b0caf!2sAtul%20Projects!5e0!3m2!1sen!2sin!4v1774506198729!5m2!1sen!2sin"
                    width="600"
                    height="450"
                    // style="border:0;" 
                    style={{ border: 0 }}
                    allowFullScreen={false}
                // referrerpolicy="no-referrer-when-downgrade"
                ></iframe>
            </div>
        </div>
    );
};

export default ContactUs;
